module.exports = __webpack_public_path__ + "img/demo_ad.01663f5e.png";